/**
 * <Address />
 *
 * NOTE: we're using address data inside data/address.js instead of having
 * a detached address file for this form.
 *
 * @parent anybody
 * @stateful
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import './Guardian.scss';
import Input from 'components/UI/Form/Fields/Input';
import ReactPhoneInput from 'components/Form/Fields/PhoneNumber'
import locale from './locale'
import validator from 'validator';

export function validateGuardian(value) {
  if(value.email && !validator.isEmail(value.email.trim())){
    return {
      ok: false,
      failed: {
        because: ['invalid_email'],
        value
      }
    }
  }
}

class Guardian extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(itemName, itemValue) {
    const {
      value,
      onChange,
    } = this.props;

    onChange({
      ...value,
      [itemName]: itemValue,
    }, itemName);
  }

  render() {
    const {name, value} = this.props;

    return (
      <div className='guardianInfo-wrapper form-input'>
        <div className='form-group guardianInfo'>
            <Input className='outline-form-field' placeholder={__('Guardian Name', locale)} onChange={(name)=>{ this.onChange('name', name); }} value={value.name} />
            <Input className='parent-email outline-form-field' placeholder={__('Guardian Email', locale)} onChange={(email)=>{ this.onChange('email', email); }} value={value.email} />
            <div>
              <ReactPhoneInput
                className='form-control'
                defaultCountry={'ca'}
                value={value.phoneParsed}
                onChange={(phoneParsed)=>{ this.onChange('phoneParsed', phoneParsed); }}
                onlyCountries={['ca', 'us']}
                disableAreaCodes={true}
              />
              <div className='tip'>{__('Guardian can use phone number to sign up and log in mobile app', locale)}</div>
            </div>
            <Input className='outline-form-field' placeholder={__('Relationship', locale)} onChange={(relationship)=>{ this.onChange('relationship', relationship); }} value={value.relationship} />

        </div>
      </div>
    )
  }
}

export default Guardian;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Guardian/index.js